import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

export const jobContextMenu = (rsrc, params) => {

  const data = params.node.data;
  const items = [];

  items.push({
    name: 'Start',
    action: () => rsrc.start(data.id),
    icon: fas.faPlay,
    disabled: data.status === 'RUN',
    visible: data.cat !== 'APPR',
    role: 'JOB_SAVE'
  });

  items.push({
    name: 'Record Failure',
    action: () => {

      rsrc.byId('skdr', 'RUN', data.lastRunId).then(run => {
        let eventObj = {
          runId: run.id,
          jobId: run.jobId,
          type: 'FINISH_FAILURE',
          msg: 'Finished job per user request',
        }

        rsrc.save('skdr', 'EVENT', eventObj)
      });
    },
    icon: fas.faInfoCircle,
    visible: params.node.data.status === 'RUN'
  });

  return items;
}